// extracted by mini-css-extract-plugin
module.exports = {"root":"LanguageSwitcher_root__iFCB_","btn":"LanguageSwitcher_btn__8qCwn","active":"LanguageSwitcher_active__ufXes","rootDark":"LanguageSwitcher_rootDark__Zq7R8"};